import { createListenerMiddleware, configureStore as createStore, isAnyOf } from '@reduxjs/toolkit';
import thunk from 'redux-thunk';
import { invalidateNavConfigCache } from '../config';
import { rootReducer } from '../reducers/RootReducer';
import { updateNavItemBookmarkState } from '../reducers/navItems';
import { initialStore } from '../reducers/utils/hydrateStore';
import { bookmarksToPersonaApiAction } from '../thunks/bookmarks/bookmarks-api';
import { getPortalId } from './getPortalId';
export const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  matcher: isAnyOf(updateNavItemBookmarkState),
  effect: async (__action, {
    dispatch
  }) => {
    dispatch(bookmarksToPersonaApiAction()).catch(() => {
      // no-op
    });
    // Invalidate nav cache so that it gets up-to-date nav persona data in nav config response
    const portalId = getPortalId();
    if (portalId) {
      await invalidateNavConfigCache(portalId);
    }
  }
});
export const configureStore = (preloadedState = initialStore) => createStore({
  middleware: [thunk, listenerMiddleware.middleware],
  devTools: {
    name: 'unified-navigation-ui'
  },
  preloadedState,
  reducer: rootReducer
});